(function($) {

    var friendshipFormValid = true;
    var friendshipFormSubmit = $('.friendship-submit');
    var friendshipRequiredFields = $('.friendship-form-wrap .required');

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    friendshipFormSubmit.on('click', function() {
        friendshipFormSubmit.addClass('loading');
        friendshipFormValid = true;
        $('.membership-payment-form-wrap .input-wrap').removeClass('has-error');
        $('.membership-payment-form-wrap .input-wrap .input-error').hide();
        $('#membership-agree').parent().removeClass('has-error');

        friendshipRequiredFields.each(function (ind, val) {
            if ($(val).val() === '') {
                friendshipFormValid = false;
                $(val).parent().addClass('has-error').find('.input-error.error-required').show();
            } else if ($(val).attr('name') === 'friendship-email') {
                if (!validateEmail($(val).val())) {
                    friendshipFormValid = false;
                    $(val).parent().addClass('has-error').find('.input-error.error-invalid').show();
                }
            }

            if (!$('#friendship-agree').is(':checked')) {
                friendshipFormValid = false;
                $('#friendship-agree').parent().addClass('has-error');
            }
        });

        if (friendshipFormValid) {

            var data = {
                'action' : 'submit_friendship',
                'name' : $('[name=friendship-name]').val(),
                'surname' : $('[name=friendship-surname]').val(),
                'phone' : $('[name=friendship-phone]').val(),
                'email' : $('[name=friendship-email]').val(),
                'district' : $('[name=friendship-location]').val(),
                'address' : $('[name=friendship-address]').val(),
            };

            $.get(postmpwp.ajax_url, data, function(response){
                if (response.success) {
                    $('.friendship-content').hide();
                    $('.supporter-status').show();
                }
            });

        } else {
            friendshipFormSubmit.removeClass('loading');
            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }
    });

})( jQuery );